<div class="content-info ">
  <div class=" mt-3 common-stepper">
    <div class="content-title">
      <h3 class="title">Products Vendor Mapping</h3>
    </div>



    <div class="tab-content">
      <!-- Step 1 -->
      <div class="tab-pane fade show active" id="step1">
        <div class="product-catg input-fileds">
          <div class="catg-fileds">
            <div class="row align-items-end">
              <div class="col-md-3 form-group">
                <label class="form-label">Vendor</label>
                <ng-select [items]="vendors" bindLabel="name" bindValue="id" [searchable]="true"
                  placeholder="Select Vendor" (change)="onVendorChange($event)">
                </ng-select>
              </div>

              @if (products.length>0 && selectedVendorId) {
              <div class="col-md-3 form-group">
                @if (!showReplace) {
                <button class="btn btn-warning" (click)="showReplace = true">Replace Vendor</button>
                }
              </div>
              }
            </div>

            <!-- Replace Vendor UI -->
            @if (showReplace) {
            <div class="row mt-3 align-items-end">
              <div class="col-md-3 form-group">
                <label class="form-label">New Vendor</label>
                <ng-select [items]="filteredVendors" bindLabel="name" bindValue="id" [searchable]="true"
                  placeholder="Select New Vendor" [(ngModel)]="selectedNewVendorId"
                  [ngModelOptions]="{standalone: true}">
                </ng-select>
              </div>
              <div class="col-md-3 form-group d-block">
                <button class="btn btn-success" (click)="replaceVendor()">Submit</button>
                <button class="btn btn-secondary ms-2" (click)="cancelReplace()">Cancel</button>
              </div>
            </div>
            }

          </div>
        </div>
      </div>
      <div class="common-table">
        <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Category</th>
                <th>Supplier</th>
                <th>Created At</th>
                <th>Base Price</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>

              @if(!products.length) {
              <tr>
                <td colspan="6" class="text-center">No Products found.</td>
              </tr>
              } @else {
              @for(product of products; track product.id) {
              <tr>
                <td>{{ product.name }}</td>
                <td>{{ product?.category?.name }}</td>
                <td>{{ product?.supplier?.name }}</td>
                <td>{{ product.createdAt | date: 'dd-MM-yy HH:mm' }}</td>
                <td>{{ product.basePrice }}</td>
                <td>
                  <span class="badge" [ngClass]="product.isActive ? 'bg-success' : 'bg-secondary'">
                    {{ product.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
              </tr>
              }
              }
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>


</div>